import { convertDatesToISO, getHeaders } from '@/config/aux'
import { DeviceMeasurement } from '../models/deviceMeasurement'
import { DeviceMeasurementsStateType } from './state'
import axios from 'axios'

export interface DeviceMeasurementsActionsType {
  getDeviceMeasurements(): Promise<void>
  getDeviceMeasurementsByDeviceId(deviceId: string): Promise<void>
  getDeviceMeasurementsBySensorId(sensorId: string): Promise<DeviceMeasurement[]>
  getDeviceMeasurementsBySensorIds(sensorIds: string[]): Promise<Record<string, DeviceMeasurement[]>>
  postDeviceMeasurements(deviceMeasurements: DeviceMeasurement): Promise<void>
  putDeviceMeasurements(deviceMeasurements: DeviceMeasurement): Promise<void>
  deleteDeviceMeasurements(id: string): Promise<void>
  // Nuevas funciones para organizar datos por tipo de sensor
  getTemperatureData(sensorIds: string[]): Promise<Array<{timestamp: string, temperature: number}>>
  getOxygenData(sensorIds: string[]): Promise<Array<{timestamp: string, oxygen: number}>>
  getBatteryData(sensorIds: string[]): Promise<Array<{timestamp: string, batteryLevel: number, voltage?: number}>>
  getTemperatureOxygenData(temperatureSensorIds: string[], oxygenSensorIds: string[]): Promise<Array<{timestamp: string, temperature: number, oxygen: number}>>
}

export const DeviceMeasurementsActions = {
  async getDeviceMeasurements(this: DeviceMeasurementsStateType) {
    try {
      this.deviceMeasurements = []
      // console.log('[DeviceMeasurements] getDeviceMeasurements')
      const query = `${process.env.VUE_APP_URL_BASE}/device-measurements`
      // console.log('[DeviceMeasurements] Query URL:', query)
      await axios.get(query, { headers: getHeaders() }).then(response => {
        // console.log('[DeviceMeasurements] Response status:', response.status)
        // console.log('[DeviceMeasurements] Response data count:', response.data?.length || 0)
        if (response.status === 200) {
          response.data.forEach((data: DeviceMeasurement) => {
            this.deviceMeasurements.push(data)
          })
        }
      })
    } catch (error) {
      console.error('[DeviceMeasurements] Error getting DeviceMeasurements', error)
    }
  },
  async getDeviceMeasurementsByDeviceId(this: DeviceMeasurementsStateType, deviceId: string) {
    try {
      this.deviceMeasurements = []
      // console.log('[DeviceMeasurements] getDeviceMeasurementsByDeviceId - deviceId:', deviceId)
      const query = `${process.env.VUE_APP_URL_BASE}/devices/${deviceId}/device-measurements`
      // console.log('[DeviceMeasurements] Query URL:', query)
      await axios.get(query, { headers: getHeaders() }).then(response => {
        // console.log('[DeviceMeasurements] Response status:', response.status)
        // console.log('[DeviceMeasurements] Response data count:', response.data?.length || 0)
        if (response.status === 200) {
          response.data.forEach((data: DeviceMeasurement) => {
            this.deviceMeasurements.push(data)
          })
        }
      })
    } catch (error) {
      console.error('[DeviceMeasurements] Error getting DeviceMeasurements by deviceId', error)
    }
  },
  async postDeviceMeasurements(this: DeviceMeasurementsStateType, deviceMeasurements: DeviceMeasurement) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/device-measurements`
      const data = convertDatesToISO(deviceMeasurements.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.deviceMeasurements.push(deviceMeasurements)
        }
      })
    } catch (error) {
      console.error('Error posting DeviceMeasurements', error)
    }
  },
  async putDeviceMeasurements(this: DeviceMeasurementsStateType, deviceMeasurements: DeviceMeasurement) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/device-measurements`
      const data = convertDatesToISO(deviceMeasurements.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.deviceMeasurements = this.deviceMeasurements.map(d => (d.id === deviceMeasurements.id ? deviceMeasurements : d))
          }
        })
    } catch (error) {
      console.error('Error updating DeviceMeasurements', error)
    }
  },
  async deleteDeviceMeasurements(this: DeviceMeasurementsStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/device-measurements/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.deviceMeasurements = this.deviceMeasurements.filter(d => d.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting DeviceMeasurements', error)
    }
  },

  // Nueva función para obtener datos por sensor ID específico
  async getDeviceMeasurementsBySensorId(this: DeviceMeasurementsStateType, sensorId: string): Promise<DeviceMeasurement[]> {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/sensors/${sensorId}/device-measurements`
      const response = await axios.get(query, { headers: getHeaders() })
      
      if (response.status === 200) {
        return response.data.map((data: DeviceMeasurement) => new DeviceMeasurement(data))
      }
      return []
    } catch (error) {
      console.error('Error getting DeviceMeasurements by sensorId', error)
      return []
    }
  },

  // Nueva función para obtener datos de múltiples sensores
  async getDeviceMeasurementsBySensorIds(this: DeviceMeasurementsStateType, sensorIds: string[]): Promise<Record<string, DeviceMeasurement[]>> {
    try {
      const result: Record<string, DeviceMeasurement[]> = {}
      
      // Realizar consultas en paralelo para todos los sensores
      const promises = sensorIds.map(async (sensorId) => {
        const query = `${process.env.VUE_APP_URL_BASE}/sensors/${sensorId}/device-measurements`
        const response = await axios.get(query, { headers: getHeaders() })
        
        if (response.status === 200) {
          const data = response.data.map((data: DeviceMeasurement) => new DeviceMeasurement(data))
          return { sensorId, data }
        }
        return { sensorId, data: [] }
      })
      
      const results = await Promise.all(promises)
      
      results.forEach(({ sensorId, data }) => {
        result[sensorId] = data
      })
      
      return result
    } catch (error) {
      console.error('Error getting DeviceMeasurements by multiple sensorIds', error)
      return {}
    }
  },

  // Función para obtener datos de temperatura organizados para gráficos
  async getTemperatureData(this: DeviceMeasurementsStateType, sensorIds: string[]): Promise<Array<{timestamp: string, temperature: number}>> {
    try {
      const result: Record<string, DeviceMeasurement[]> = {}
      
      // Realizar consultas en paralelo para todos los sensores de temperatura
      const promises = sensorIds.map(async (sensorId) => {
        const query = `${process.env.VUE_APP_URL_BASE}/sensors/${sensorId}/device-measurements`
        const response = await axios.get(query, { headers: getHeaders() })
        
        if (response.status === 200) {
          const data = response.data.map((data: DeviceMeasurement) => new DeviceMeasurement(data))
          return { sensorId, data }
        }
        return { sensorId, data: [] }
      })
      
      const results = await Promise.all(promises)
      
      results.forEach(({ sensorId, data }) => {
        result[sensorId] = data
      })
      
      const combinedData: Array<{timestamp: string, temperature: number}> = []
      
      // Combinar datos de todos los sensores de temperatura
      Object.values(result).forEach((sensorData: DeviceMeasurement[]) => {
        sensorData.forEach((data: DeviceMeasurement) => {
          combinedData.push({
            timestamp: data.time.toISOString(),
            temperature: data.value
          })
        })
      })
      
      // Ordenar por timestamp
      return combinedData.sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime())
    } catch (error) {
      console.error('Error getting temperature data', error)
      return []
    }
  },

  // Función para obtener datos de oxígeno organizados para gráficos
  async getOxygenData(this: DeviceMeasurementsStateType, sensorIds: string[]): Promise<Array<{timestamp: string, oxygen: number}>> {
    try {
      const result: Record<string, DeviceMeasurement[]> = {}
      
      // Realizar consultas en paralelo para todos los sensores de oxígeno
      const promises = sensorIds.map(async (sensorId) => {
        const query = `${process.env.VUE_APP_URL_BASE}/sensors/${sensorId}/device-measurements`
        const response = await axios.get(query, { headers: getHeaders() })
        
        if (response.status === 200) {
          const data = response.data.map((data: DeviceMeasurement) => new DeviceMeasurement(data))
          return { sensorId, data }
        }
        return { sensorId, data: [] }
      })
      
      const results = await Promise.all(promises)
      
      results.forEach(({ sensorId, data }) => {
        result[sensorId] = data
      })
      
      const combinedData: Array<{timestamp: string, oxygen: number}> = []
      
      // Combinar datos de todos los sensores de oxígeno
      Object.values(result).forEach((sensorData: DeviceMeasurement[]) => {
        sensorData.forEach((data: DeviceMeasurement) => {
          combinedData.push({
            timestamp: data.time.toISOString(),
            oxygen: data.value
          })
        })
      })
      
      // Ordenar por timestamp
      return combinedData.sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime())
    } catch (error) {
      console.error('Error getting oxygen data', error)
      return []
    }
  },

  // Función para obtener datos de batería organizados para gráficos
  async getBatteryData(this: DeviceMeasurementsStateType, sensorIds: string[]): Promise<Array<{timestamp: string, batteryLevel: number, voltage?: number}>> {
    try {
      const result: Record<string, DeviceMeasurement[]> = {}
      
      // Realizar consultas en paralelo para todos los sensores de batería
      const promises = sensorIds.map(async (sensorId) => {
        const query = `${process.env.VUE_APP_URL_BASE}/sensors/${sensorId}/device-measurements`
        const response = await axios.get(query, { headers: getHeaders() })
        
        if (response.status === 200) {
          const data = response.data.map((data: DeviceMeasurement) => new DeviceMeasurement(data))
          return { sensorId, data }
        }
        return { sensorId, data: [] }
      })
      
      const results = await Promise.all(promises)
      
      results.forEach(({ sensorId, data }) => {
        result[sensorId] = data
      })
      
      const combinedData: Array<{timestamp: string, batteryLevel: number, voltage?: number}> = []
      
      // Combinar datos de todos los sensores de batería
      Object.values(result).forEach((sensorData: DeviceMeasurement[]) => {
        sensorData.forEach((data: DeviceMeasurement) => {
          const batteryReading: {timestamp: string, batteryLevel: number, voltage?: number} = {
            timestamp: data.time.toISOString(),
            batteryLevel: data.value
          }
          
          // Si el sensor también tiene voltaje (podría estar en valueText o ser otro sensor)
          if (data.valueText && !isNaN(parseFloat(data.valueText))) {
            batteryReading.voltage = parseFloat(data.valueText)
          }
          
          combinedData.push(batteryReading)
        })
      })
      
      // Ordenar por timestamp
      return combinedData.sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime())
    } catch (error) {
      console.error('Error getting battery data', error)
      return []
    }
  },

  // Función para obtener datos combinados de temperatura y oxígeno
  async getTemperatureOxygenData(this: DeviceMeasurementsStateType, temperatureSensorIds: string[], oxygenSensorIds: string[]): Promise<Array<{timestamp: string, temperature: number, oxygen: number}>> {
    try {
      // Obtener datos de temperatura
      const temperatureResult: Record<string, DeviceMeasurement[]> = {}
      const temperaturePromises = temperatureSensorIds.map(async (sensorId) => {
        const query = `${process.env.VUE_APP_URL_BASE}/sensors/${sensorId}/device-measurements`
        const response = await axios.get(query, { headers: getHeaders() })
        
        if (response.status === 200) {
          const data = response.data.map((data: DeviceMeasurement) => new DeviceMeasurement(data))
          return { sensorId, data }
        }
        return { sensorId, data: [] }
      })
      
      // Obtener datos de oxígeno
      const oxygenResult: Record<string, DeviceMeasurement[]> = {}
      const oxygenPromises = oxygenSensorIds.map(async (sensorId) => {
        const query = `${process.env.VUE_APP_URL_BASE}/sensors/${sensorId}/device-measurements`
        const response = await axios.get(query, { headers: getHeaders() })
        
        if (response.status === 200) {
          const data = response.data.map((data: DeviceMeasurement) => new DeviceMeasurement(data))
          return { sensorId, data }
        }
        return { sensorId, data: [] }
      })
      
      const [temperatureResults, oxygenResults] = await Promise.all([
        Promise.all(temperaturePromises),
        Promise.all(oxygenPromises)
      ])
      
      temperatureResults.forEach(({ sensorId, data }) => {
        temperatureResult[sensorId] = data
      })
      
      oxygenResults.forEach(({ sensorId, data }) => {
        oxygenResult[sensorId] = data
      })
      
      // Procesar datos de temperatura
      const temperatureData: Array<{timestamp: string, temperature: number}> = []
      Object.values(temperatureResult).forEach((sensorData: DeviceMeasurement[]) => {
        sensorData.forEach((data: DeviceMeasurement) => {
          temperatureData.push({
            timestamp: data.time.toISOString(),
            temperature: data.value
          })
        })
      })
      
      // Procesar datos de oxígeno
      const oxygenData: Array<{timestamp: string, oxygen: number}> = []
      Object.values(oxygenResult).forEach((sensorData: DeviceMeasurement[]) => {
        sensorData.forEach((data: DeviceMeasurement) => {
          oxygenData.push({
            timestamp: data.time.toISOString(),
            oxygen: data.value
          })
        })
      })
      
      // Crear un mapa de timestamps para facilitar la combinación
      const oxygenMap = new Map<string, number>()
      oxygenData.forEach((data: {timestamp: string, oxygen: number}) => {
        oxygenMap.set(data.timestamp, data.oxygen)
      })
      
      // Combinar datos donde tengamos ambas lecturas
      const combinedData: Array<{timestamp: string, temperature: number, oxygen: number}> = []
      
      temperatureData.forEach((tempData: {timestamp: string, temperature: number}) => {
        const oxygenValue = oxygenMap.get(tempData.timestamp)
        if (oxygenValue !== undefined) {
          combinedData.push({
            timestamp: tempData.timestamp,
            temperature: tempData.temperature,
            oxygen: oxygenValue
          })
        }
      })
      
      return combinedData.sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime())
    } catch (error) {
      console.error('Error getting temperature-oxygen combined data', error)
      return []
    }
  },
}
